import { useSearchParams } from 'react-router-dom';
import { Dashboard } from '../[campaignId]';
import { DashboardProps } from '../dashboardConfig';

/**
 * Read-only wrapper around the My Progress <Dashboard>. Reached from the My Team
 * page (`.../myTeam/user?id=<userId>&tId=<teamId>`) so a team leader / member can
 * view another member's progress using the exact same UI, with all action buttons
 * hidden/disabled.
 */
const MemberProgressView = (props: Omit<DashboardProps, 'viewUserId' | 'viewTeamId' | 'readOnly'>) => {
  const [searchParams] = useSearchParams();
  const viewUserId = searchParams.get('id') ?? undefined;
  const viewTeamId = searchParams.get('tId') ?? undefined;

  return <Dashboard {...props} viewUserId={viewUserId} viewTeamId={viewTeamId} readOnly />;
};

export default MemberProgressView;
